import { useTranslation } from '~src/i18n/use-translation';

import { useTranslatedFormLabel, useUISchema } from '../schema/hooks';

export const Validate = () => {
  const { t } = useTranslation();

  const validateDescription = (currentValue: string | undefined) => {
    if (!currentValue) {
      return undefined;
    }

    if (/^\s+$/.test(currentValue)) {
      return t('carrierContracts.details.validateFieldOnlySpacing', {
        field: t('common.description'),
      });
    } else if (/^\s/.test(currentValue)) {
      return t('carrierContracts.details.validateFieldStartSpacing', {
        field: t('common.description'),
      });
    } else if (/\s$/.test(currentValue)) {
      return t('carrierContracts.details.validateFieldEndSpacing', {
        field: t('common.description'),
      });
    }

    return undefined;
  };

  const validateName = (currentValue: string | undefined) => {
    if (!currentValue) {
      return undefined;
    }

    if (/^\s+$/.test(currentValue)) {
      return t('carrierContracts.details.validateFieldOnlySpacing', { field: t('common.name') });
    } else if (/^\s/.test(currentValue)) {
      return t('carrierContracts.details.validateFieldStartSpacing', { field: t('common.name') });
    } else if (/\s$/.test(currentValue)) {
      return t('carrierContracts.details.validateFieldEndSpacing', { field: t('common.name') });
    }

    return undefined;
  };

  const validationRules = {
    description: {
      validate: validateDescription,
    },
    name: {
      required: t('common.fieldRequired', {
        field: t('common.name'),
      }),
      validate: validateName,
    },
    schema_id: {
      required: t('common.fieldRequired', {
        field: t('common.carrierProduct'),
      }),
    },
  };

  return validationRules;
};

export const ValidateSchema = (path: string, schemaId: string) => {
  const label = useTranslatedFormLabel({ path });

  const { isOptional } = useUISchema({ path, schemaId });
  const { t } = useTranslation();

  if (!isOptional) {
    return {
      required: t('common.fieldRequired', {
        field: label,
      }),
    };
  }

  return {};
};
